// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoagindPage_loadingScreen__ANXy1","loadingText":"LoagindPage_loadingText__mSzP9","customCircularProgress":"LoagindPage_customCircularProgress__Mf9Uk"};